import React from 'react'
import '../Common/Style.css';

interface FailurePoupProps {
  message: string
}

const FailurePoup: React.FC<FailurePoupProps> = ({
  message
}) => {

      return (
        <div className="alert alert-danger gap-3 d-flex justify-content-center" role="alert" style={{position: "fixed"}}>
          {(message && message.trim() !== "") ? message : "Something went wrong!"}
        </div>
      )
}

export default FailurePoup